import React, { useState, useEffect, useRef } from "react";

import "./forms.css";
import { MdFileUpload } from "react-icons/md";

const ImageUpload = ({ handleFiles, reset }) => {
  const [isOver, setIsOver] = useState(false);
  const [uploadFiles, setUploadFiles] = useState(null);
  const [message, setMessage] = useState("");
  const [tempImageUrl, setTempImageUrl] = useState("");
  const uploadRef = useRef(null);

  const init = () => {
    setIsOver(false);
    setUploadFiles(null);
    setMessage("");
    setTempImageUrl("");
  };

  useEffect(() => {
    init();
    uploadRef.current.value = null;
  }, [reset]);

  const handleDragLeave = (e) => {
    setIsOver(false);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsOver(true);
  };

  const validateFile = (file) => {
    if (!file) {
      return {
        success: false,
        message: "No se ha subido ningun archivo.",
      };
    } else if (
      !file.type.startsWith("image") ||
      file.size > Number.parseInt(5 * 1024 * 1024)
    ) {
      return {
        success: false,
        message: "Archivo no permitido.",
      };
    } else return { success: true };
  };
  const handleOnDrop = (e) => {
    e.preventDefault();

    const files = e.dataTransfer.files;

    if (files.length > 0) {
      const file = files[0];
      if (file.type.startsWith("image")) {
        /// cambiar si es para varias
        setUploadFiles(file);
        setIsOver(false);
        const url = URL.createObjectURL(file);
        setTempImageUrl(url);
      } else {
        setMessage("El fichero tiene que ser una imagen.");
      }
    } else {
      setMessage("Por favor, seleccione una imagen para el producto.");
    }
  };

  const handleChange = (e) => {
    try {
      init();
      const files = e.target.files[0];

      const validations = validateFile(files);

      if (!validations.success) {
        throw new Error(validations.message);
      }
      let url = URL.createObjectURL(files);

      setUploadFiles(files);
      setTempImageUrl(url);
      handleFiles(files);
    } catch (error) {
      setMessage(error.message);
    }
  };

  return (
    <div>
      <div className={`image-upload ${isOver ? "on-over" : ""}`}>
        <input
          type="file"
          accept="image/*"
          id="image-upload"
          onChange={handleChange}
          style={{ display: "none" }}
          ref={uploadRef}
        />
        <label
          htmlFor="image-upload"
          className="upload-container"
          onChange={handleChange}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleOnDrop}
        >
          <MdFileUpload className="upload-icon animate-bounce" />
          <span>
            <span className="strong-blue">Sube o arrastra</span> una imagen del
            producto aqui
          </span>
          <span className="text-xs mt-2 font-serif font-thin text-slate-500">
            {" "}
            JPEG , JPG ,PNG / Max. 2MB
          </span>
        </label>
      </div>
      <div className="flex mt-1 w-full items-center grow">
        {uploadFiles ? (
          <div className="relative gap-1 upload-item flex p-[5px] text-sky-500 text-sm rounded-lg mt-2 underline">
            <div className="peer shrink">{uploadFiles.name}</div>

            <img
              src={tempImageUrl}
              alt="Image-Preview"
              className="peer-hover:block hidden w-[100px] h-[100px] object-cover"
            />
          </div>
        ) : (
          <span
            className={
              message
                ? "rounded-[5px] text-red-400 text-sm font-semibold p-1 flex justify-center items-center bg-rose-100"
                : "hidden"
            }
          >
            {message}
          </span>
        )}
      </div>
    </div>
  );
};

export default ImageUpload;
